module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-3-131b8404c2199f24f077b9d6f4270649.svg";